export default __webpack_public_path__ + "media/components/blocks/ProUpsell/pro_header-13d8261bb8108b3201bcd9d26852b8e6.png";